import { render, staticRenderFns } from "./MessagesOverview.vue?vue&type=template&id=335d1f88&"
import script from "./MessagesOverview.vue?vue&type=script&lang=ts&"
export * from "./MessagesOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
installComponents(component, {VContainer,VDataIterator})
